import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[ag-grid-resize]',
    standalone: false
})

/*
    URL: https://stackoverflow.com/questions/54038024/warning-grid-zero-width-when-using-ag-grids-sizecolumnstofit-on-two-separat

    the idea from yurzui: having a directive to listen to some events from ag-grid so we dont need to duplicate in many places.
    In some cases (may be future) we may need to bring back those events (gridReady and rowDataChanged) to their components.
    gridReady:
        from ag-grid.
        It get called when data is loaded to table.
    rowdatachanged:
        from ag-grid.
        it get called when table is reloaded with new data from backend.

*/
export class AgGridResizeDirective {
  private gridApi;

  @HostListener('window:resize') onResize() {
    if (!this.gridApi) {
      return;
    }
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  @HostListener('gridReady', ['$event']) onGridReady(params) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  @HostListener('rowDataChanged', ['$event']) onRowDataCHanged(params) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }
}
